export class BankingSafeCountDetailHistoryDto {
  createdDate: Date;
  safeCountHeaderId: number;
  key: string;
  action: string;
  countedWhen: string;
  lastModifiedUser: string;
  lastModifiedEmployeeName?: string;
  safeId?: number;
  safeName?: string;
}
